import React from 'react';

/**
 * EditorTabs - Workflow-based tab navigation for ContentEditor
 *
 * Shows tabs with completion indicators:
 * - Red dot: Required but incomplete
 * - Green checkmark: Completed
 * - Neutral: Optional or info-only
 */
const EditorTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex gap-1 bg-gray-900 border-b border-gray-700 p-1 rounded-t-lg overflow-x-auto">
      {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const showRedDot = tab.required && !tab.complete;
        const showGreen = tab.complete;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              px-4 py-2 text-sm font-medium transition-colors relative whitespace-nowrap rounded-md
              ${isActive
                ? 'bg-gray-800 text-gray-100'
                : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800/50'}
              ${showRedDot && !isActive ? 'text-red-400' : ''}
              ${showGreen && !isActive ? 'text-green-400' : ''}
            `}
          >
            {/* Red dot indicator for required incomplete */}
            {showRedDot && (
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
            )}

            {tab.label}

            {/* Green checkmark for completed */}
            {showGreen && (
              <span className="ml-1.5 text-green-400">✓</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default EditorTabs;
